import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ComplianceWidgetState {
  Control_id: string;
  Version_id: string;
  framework?: string;
}

const initialState: ComplianceWidgetState = {
  Control_id: "",
  Version_id: "",
  framework: "",
};

const ComplianceWidget = createSlice({
  name: "ComplianceWidget",
  initialState,
  reducers: {
    setComplianceWidget(state, action: PayloadAction<{ Control_id: string; Version_id: string; framework?: string }>) {
      state.Control_id = action.payload.Control_id;
      state.Version_id = action.payload.Version_id;
      state.framework = action.payload.framework
    },
  },
});

export const { setComplianceWidget } = ComplianceWidget.actions;
export default ComplianceWidget.reducer;
